/**
 * @generated SignedSource<<92cf02c276aaf4fe5134401479a9da51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EstimateStatus = "ACCEPTED" | "COMPLETED" | "DECLINED" | "DRAFT" | "SENT" | "%future added value";
export type AcceptEstimateInput = {
  webToken: string;
};
export type AcceptEstimateMutation$variables = {
  input: AcceptEstimateInput;
};
export type AcceptEstimateMutation$data = {
  readonly acceptEstimate: {
    readonly estimate: {
      readonly id: string;
      readonly status: EstimateStatus;
    } | null | undefined;
  } | null | undefined;
};
export type AcceptEstimateMutation = {
  response: AcceptEstimateMutation$data;
  variables: AcceptEstimateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcceptEstimatePayload",
    "kind": "LinkedField",
    "name": "acceptEstimate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Estimate",
        "kind": "LinkedField",
        "name": "estimate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptEstimateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptEstimateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d641408f79158cfb18e032d774e9e382",
    "id": null,
    "metadata": {},
    "name": "AcceptEstimateMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptEstimateMutation(\n  $input: AcceptEstimateInput!\n) {\n  acceptEstimate(input: $input) {\n    estimate {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac3f6363965880335276856c1e113da4";

export default node;
